module.exports = __webpack_public_path__ + "static/media/rocket.016de29f.png";